export const QA_NAME_INTEGRATIONS_IMPORT_LOG =
  'rentalPortalIntegrationsImportLog'

export const QA_NAME_INTEGRATIONS_IMPORT_LOG_STATUS =
  'rentalPortalIntegrationsImportLogStatus'

export const QA_NAME_INTEGRATIONS_IMPORT_LOG_SOURCE =
  'rentalPortalIntegrationsImportLogSource'

export const QA_NAME_INTEGRATIONS_IMPORT_LOG_RETRY =
  'rentalPortalIntegrationsImportLogRetry'

export const QA_NAME_INTEGRATIONS_IMPORT_RUN =
  'rentalPortalIntegrationsImportRun'

export const QA_NAME_INTEGRATIONS_IMPORT_RUN_OUTCOME =
  'rentalPortalIntegrationsImportRunOutcome'

export const QA_NAME_INTEGRATIONS_IMPORT_RUN_REPROCESS =
  'rentalPortalIntegrationsImportRunReprocess'

export const QA_NAME_INTEGRATIONS_IMPORT_RUN_EXPORT =
  'rentalPortalIntegrationsImportRunExport'

export const IMPORT_RUN_ACTION = {
  reprocess: 'reprocess',
}

export const IMPORT_RUN_STATUS = {
  failed: 'failed',
  partial: 'partial',
  running: 'running',
  success: 'success',
}

export const IMPORT_RUN_STATUSES = {
  [IMPORT_RUN_STATUS.failed]: {
    text: 'RentalPortal.IntegrationsRunStatusFailedKey',
    textColor: 'var(--color-error)',
  },
  [IMPORT_RUN_STATUS.partial]: {
    text: 'RentalPortal.IntegrationsRunStatusPartialKey',
    textColor: 'var(--color-warning)',
  },
  [IMPORT_RUN_STATUS.running]: {
    text: 'RentalPortal.IntegrationsRunStatusRunningKey',
    textColor: 'var(--color-info)',
  },
  [IMPORT_RUN_STATUS.success]: {
    text: 'RentalPortal.IntegrationsRunStatusSuccessKey',
    textColor: 'var(--color-success)',
  },
}

export const IMPORT_CHANGE_OUTCOME = {
  acceptedImport: 'accepted_import',
  applied: 'applied',
  blockedPortalOwned: 'blocked_portal_owned',
  blockedUndeclared: 'blocked_undeclared',
  held: 'held',
  keptPortal: 'kept_portal',
  reverted: 'reverted',
}

export const IMPORT_CHANGE_OUTCOME_LABEL_KEY = {
  [IMPORT_CHANGE_OUTCOME.acceptedImport]:
    'RentalPortal.IntegrationsRunOutcomeAcceptedImportKey',
  [IMPORT_CHANGE_OUTCOME.applied]:
    'RentalPortal.IntegrationsRunOutcomeAppliedKey',
  [IMPORT_CHANGE_OUTCOME.blockedPortalOwned]:
    'RentalPortal.IntegrationsRunOutcomeBlockedPortalOwnedKey',
  [IMPORT_CHANGE_OUTCOME.blockedUndeclared]:
    'RentalPortal.IntegrationsRunOutcomeBlockedUndeclaredKey',
  [IMPORT_CHANGE_OUTCOME.held]: 'RentalPortal.IntegrationsRunOutcomeHeldKey',
  [IMPORT_CHANGE_OUTCOME.keptPortal]:
    'RentalPortal.IntegrationsRunOutcomeKeptPortalKey',
  [IMPORT_CHANGE_OUTCOME.reverted]:
    'RentalPortal.IntegrationsRunOutcomeRevertedKey',
}

export const IMPORT_RUN_COLUMN_NAME = {
  Applied: 'fields_applied',
  Blocked: 'fields_blocked',
  Held: 'fields_held',
  Records: 'records_received',
  Source: 'source_label',
  Started: 'started_at',
  Status: 'status',
}

export const IMPORT_RUN_COLUMNS_CONFIG = {
  [IMPORT_RUN_COLUMN_NAME.Applied]: {
    index: 4,
    name: IMPORT_RUN_COLUMN_NAME.Applied,
    ordering_field: null,
    title: 'RentalPortal.IntegrationsRunAppliedColumnKey',
    visible: true,
    width: 120,
  },
  [IMPORT_RUN_COLUMN_NAME.Blocked]: {
    index: 5,
    name: IMPORT_RUN_COLUMN_NAME.Blocked,
    ordering_field: null,
    title: 'RentalPortal.IntegrationsRunBlockedColumnKey',
    visible: true,
    width: 120,
  },
  [IMPORT_RUN_COLUMN_NAME.Held]: {
    index: 6,
    name: IMPORT_RUN_COLUMN_NAME.Held,
    ordering_field: null,
    title: 'RentalPortal.IntegrationsRunHeldColumnKey',
    visible: true,
    width: 140,
  },
  [IMPORT_RUN_COLUMN_NAME.Records]: {
    index: 3,
    name: IMPORT_RUN_COLUMN_NAME.Records,
    ordering_field: null,
    title: 'RentalPortal.IntegrationsRunRecordsColumnKey',
    visible: true,
    width: 120,
  },
  [IMPORT_RUN_COLUMN_NAME.Source]: {
    index: 1,
    name: IMPORT_RUN_COLUMN_NAME.Source,
    ordering_field: null,
    title: 'RentalPortal.IntegrationsRunSourceColumnKey',
    visible: true,
    width: 160,
  },
  [IMPORT_RUN_COLUMN_NAME.Started]: {
    index: 0,
    name: IMPORT_RUN_COLUMN_NAME.Started,
    ordering_field: null,
    title: 'RentalPortal.IntegrationsRunStartedColumnKey',
    visible: true,
    width: 200,
  },
  [IMPORT_RUN_COLUMN_NAME.Status]: {
    index: 2,
    name: IMPORT_RUN_COLUMN_NAME.Status,
    ordering_field: null,
    title: 'RentalPortal.IntegrationsRunStatusColumnKey',
    visible: true,
    width: 160,
  },
}

export const IMPORT_CHANGE_COLUMN_NAME = {
  Entity: 'entity',
  Field: 'field',
  NewValue: 'new_value',
  OldValue: 'old_value',
  Outcome: 'outcome',
  Record: 'record_label',
}

export const IMPORT_CHANGE_COLUMNS_CONFIG = {
  [IMPORT_CHANGE_COLUMN_NAME.Entity]: {
    index: 0,
    name: IMPORT_CHANGE_COLUMN_NAME.Entity,
    ordering_field: null,
    title: 'RentalPortal.IntegrationsOwnershipEntityColumnKey',
    visible: true,
    width: 120,
  },
  [IMPORT_CHANGE_COLUMN_NAME.Field]: {
    index: 2,
    name: IMPORT_CHANGE_COLUMN_NAME.Field,
    ordering_field: null,
    title: 'RentalPortal.IntegrationsOwnershipFieldColumnKey',
    visible: true,
    width: 160,
  },
  [IMPORT_CHANGE_COLUMN_NAME.NewValue]: {
    index: 4,
    name: IMPORT_CHANGE_COLUMN_NAME.NewValue,
    ordering_field: null,
    title: 'RentalPortal.IntegrationsRunNewValueColumnKey',
    visible: true,
    width: 200,
  },
  [IMPORT_CHANGE_COLUMN_NAME.OldValue]: {
    index: 3,
    name: IMPORT_CHANGE_COLUMN_NAME.OldValue,
    ordering_field: null,
    title: 'RentalPortal.IntegrationsRunOldValueColumnKey',
    visible: true,
    width: 200,
  },
  [IMPORT_CHANGE_COLUMN_NAME.Outcome]: {
    index: 5,
    name: IMPORT_CHANGE_COLUMN_NAME.Outcome,
    ordering_field: null,
    title: 'RentalPortal.IntegrationsRunOutcomeColumnKey',
    visible: true,
    width: 220,
  },
  [IMPORT_CHANGE_COLUMN_NAME.Record]: {
    index: 1,
    name: IMPORT_CHANGE_COLUMN_NAME.Record,
    ordering_field: null,
    title: 'RentalPortal.IntegrationsRunRecordColumnKey',
    visible: true,
    width: 220,
  },
}

export const IMPORT_LOG_PAGE_SIZE = 20

export const IMPORT_LOG_SKELETON_ROWS = 10

export const IMPORT_LOG_FILTER_ALL = 'all'

export const IMPORT_LOG_READ_KEY_SEPARATOR = '|'
